<template>
<div class="raindrop">
  <div class="raindrop__ripple"></div>
  <div class="raindrop__drop"></div>
</div>
</template>

<script>
export default {
  name: 'raindrop'
}
</script>

<style lang="scss">
@keyframes rain {
  0% {
    transform: translate3d(0%,0%,0);
  }
  75% {
    transform: translate3d(-625%,1111%,0);
  }
  100% {
    transform: translate3d(-625%,1111%,0);
  }
}
@keyframes waterdrop {
  0% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  85% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@keyframes ripple {
  0% {
    opacity: 1;
    transform: scale3d(0,0,1);
  }
  75% {
    opacity: 1;
    transform: scale3d(0,0,1);
  }
  100% {
    opacity: 0;
    transform: scale3d(1,1,1);
  }
}
.raindrop {
  position: relative;
  animation: rain 0.75s linear infinite;
  &__drop {
    position: relative;
    width: fluid(8px);
    height: fluid(18px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/water-drop.svg');
    animation: waterdrop 0.75s linear infinite;
  }
  &__ripple {
    position: absolute;
    top: 100%;
    left: 50%;
    width: fluid(50px);
    height: fluid(10px);
    margin: fluid(-5px) 0 0 fluid(-25px);
    border-radius: 50%;
    border: fluid(1px) solid #FFF;
    transform: scale3d(0,0,1);
    animation: ripple 0.75s linear infinite;
  }
}
</style>
